import React from 'react'
import moment from 'moment'
import AnDatePicker from './DatePicker'

// Medicine packaging labels expiry as month/year (e.g. "EXP 08/2026"),
// meaning the drug is usable through the last day of that month. Collect
// month + year only and snap to the last day of the month (at midday, so
// timezone serialisation can't shift it across a day boundary) — otherwise
// staff keying "valid until September" as 01/09 record an extra day, and
// mobile's MM/YY display shows a whole extra month.
const ExpiryDatePicker = ({ onChange, ...props }) => (
  <AnDatePicker
    views={['year', 'month']}
    format="MM/YYYY"
    onChange={(value) =>
      onChange(
        value && moment(value).isValid()
          ? moment(value).endOf('month').startOf('day').hour(12)
          : value,
      )
    }
    {...props}
  />
)

export default ExpiryDatePicker
